import { render, staticRenderFns } from "./SingleHruSelector.vue?vue&type=template&id=23c036c0&"
import script from "./SingleHruSelector.vue?vue&type=script&lang=js&"
export * from "./SingleHruSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports